import React from 'react';
import { Badge } from '@zoopla-eng/zds/badges';
import { badgesListStyle } from './badges.styles.css';

type BadgesProps = {
    values: string[];
};

const Badges: React.FC<BadgesProps> = ({ values = [] }) => {
    return values.length > 0 ? (
        <ul className={badgesListStyle}>
            {values.map((value) => (
                <li key={value}>
                    <Badge level={4} text={value} />
                </li>
            ))}
        </ul>
    ) : null;
};

export { Badges };
